import type { Ref } from "react";

// Vectors exported from Figma component set 3154:547 — do not redraw or tweak paths.
export const CheckGlyph = ({
    className,
    ref,
}: Readonly<{ className?: string; ref?: Ref<SVGSVGElement> }>) => (
    <svg
        ref={ref}
        className={className}
        width="12"
        height="12"
        viewBox="0 0 12 12"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M1.5 6.2L4.3 9L10.3 3"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export const IndeterminateGlyph = ({
    className,
    ref,
}: Readonly<{ className?: string; ref?: Ref<SVGSVGElement> }>) => (
    <svg
        ref={ref}
        className={className}
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        aria-hidden="true"
    >
        <path d="M4 8H12" stroke="currentColor" strokeLinecap="round" />
    </svg>
);
